import axios from '@/services/api';


export const getList = async ({ commit }) => {

    const response = await axios.get('/provinces')

    const { data } = response;

    try {
        if (data) {
            commit('setList', data);
        }

    } catch (e) {
        console.log(e);
    }

};

export const getEntityById = async ({ commit }, id) => {

    const response = await axios.get(`/provinces/${id}`)

    const { data } = response;

    try {
        if (data) {
            commit('setCurrentEntity', data);
        }

    } catch (e) {
        console.log(e);
    }
}

export const add = async (_, payload) => {

    return await axios.post("provinces", payload)
        .then((data) => {
            console.log(data);
        })
        .catch((e) => {
            console.log(e);
        });
};

export const edit = async ({ commit }, payload) => {

    return await axios.put("provinces/" + payload['id'], payload)
        .then((response) => response.json())
        .then((data) => {
            commit('setList', data.data);
        })
        .catch((e) => {
            console.log(e);
        });
};

export const deleteItem= async ({ commit }, id) => {

    await axios.delete(`/provinces/${id}`)

    try {
        commit('setLoading', false);
    } catch (e) {
        console.log(e);
    }
};

